class LoadMore extends window.BAO.CustomElement() {
  setupListeners () {
    this.button = this.els.button.element

    if (this.button) {
      this.listeners.add(this.button, 'click', this.handleClick.bind(this))
    }

    this.restorePages()
  }

  async restorePages () {
    const currentPage = Number(
      new URL(window.location.href).searchParams.get('page'),
    ) || 1

    if (currentPage <= 1) return

    const grid = document.getElementById('product-grid')

    if (!grid) return

    const pages = await Promise.all(
      Array.from(
        { length: currentPage },
        (_, index) => this.fetchPage(index + 1),
      ),
    )

    const firstPage = pages[0]
    const currentPageDoc = pages[currentPage - 1]

    if (!firstPage || !currentPageDoc) return

    grid.innerHTML = ''

    let order = 0

    pages.forEach((doc) => {
      doc
        ?.querySelectorAll('#product-grid [data-load-more-product]')
        .forEach((product) => {
          order += 1

          product.style.setProperty(
            '--ProductGrid-ItemOrder',
            order,
          )

          grid.append(product)
        })
    })

    firstPage
      .querySelectorAll('#product-grid [data-load-more-promo]')
      .forEach((promo) => {
        grid.append(promo)
      })

    this.updatePagination(currentPageDoc)

    if (typeof window.initializeScrollAnimationTrigger === 'function') {
      window.initializeScrollAnimationTrigger()
    }
  }

  async fetchPage (page) {
    const url = new URL(window.location.href)

    if (page === 1) {
      url.searchParams.delete('page')
    } else {
      url.searchParams.set('page', page)
    }

    const response = await fetch(url)

    if (!response.ok) return

    return new DOMParser().parseFromString(
      await response.text(),
      'text/html',
    )
  }

  async handleClick (event) {
    event.preventDefault()

    if (this.loading) return

    const url = this.button?.dataset.nextUrl
    const grid = document.getElementById('product-grid')

    if (!url || !grid) return

    this.loading = true
    this.button.disabled = true

    try {
      const response = await fetch(url)

      if (!response.ok) return

      const doc = new DOMParser().parseFromString(
        await response.text(),
        'text/html',
      )

      const nextGrid = doc.getElementById('product-grid')

      if (!nextGrid) return

      let order = grid.querySelectorAll(
        '[data-load-more-product]',
      ).length

      nextGrid
        .querySelectorAll('[data-load-more-product]')
        .forEach((product) => {
          order += 1

          product.style.setProperty(
            '--ProductGrid-ItemOrder',
            order,
          )

          grid.append(product)
        })

      this.updateURL(url)
      this.updatePagination(doc)

      if (typeof window.initializeScrollAnimationTrigger === 'function') {
        window.initializeScrollAnimationTrigger()
      }
    } finally {
      this.loading = false

      if (this.button?.isConnected) {
        this.button.disabled = false
      }
    }
  }

  updatePagination (doc) {
    const nextButton = doc.querySelector('[data-load-more-el="button"]')
    const nextUrl = nextButton?.dataset.nextUrl

    if (!this.button) return

    if (nextUrl) {
      this.button.dataset.nextUrl = nextUrl
      this.button.hidden = false
    } else {
      this.button.removeAttribute('data-next-url')
      this.button.hidden = true
    }
  }

  updateURL (url) {
    const page = new URL(url, window.location.origin)
      .searchParams
      .get('page')

    const currentURL = new URL(window.location.href)

    if (page) {
      currentURL.searchParams.set('page', page)
    }

    history.pushState({}, '', currentURL)
  }
}

if (!customElements.get('load-more')) {
  customElements.define('load-more', LoadMore)
}
